import Vue from "vue";
import Vuex from "vuex";
import { ride1, newsIcon } from "../components/images/home/index";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    imgindex: 0,
    currentIndex: 0,

    description: [
      {
        header: `フリマ`,
        body: [
          {
            title: "NANAフリマ",
            content: [
              {
                text:
                  "「NANAフリマ」とは、中国にいながら、日本語で、個人間のモノの売り買いを楽しめるフリマ機能です！"
              }
            ]
          },
          {
            title: "NANAフリマの特長",
            content: [
              {
                text: "・全て日本語による操作が可能です。"
              },
              {
                text:
                  "・多くの決済方法（日本のクレジットカード含む）が選択可能です。"
              },
              {
                text:
                  "・配送方法（配送or直接受け渡し）を選択することが可能です。"
              },
              {
                text:
                  "・第三者エクスロー支払方式を活用することにより双方にリスクの少ないお取引が可能です。"
              },
              {
                text: "・中国人ユーザーの方への販売が期待できます。"
              }
            ]
          }
        ],
        listUrl: require("../components/images/home/agent.png")
      },
      {
        header: `E Cモール`,
        body: [
          {
            title: "KauKauモール",
            content: [
              {
                text: `特選ストアが集う「KauKauモール」は、日本語環境でショッピングが楽しめる“ネット特選街”です。中国在住の日本人が欲しいと感じるツボを押さえた品揃えをモットーに、タイムリーな配達を保証。ご決済には、日本のクレジットカードも使えて便利です！`
              }
            ]
          },
          {
            title: "購入代行",
            content: [
              {
                text: `お酒類、食品、日用品、電化製品など、ご自分で探すことが難しい
									個性ある商品の購入をNanacoが代行します。
									複数のECプラットフォームで探していた商品を、Nanacoが
									ワンストップで行うことで、みなさまのニーズにお応えします。`
              }
            ]
          }
        ],
        listUrl: require("../components/images/home/food.png")
      },
      {
        header: `ニュース・邦人NAVI`,
        body: [
          {
            title: "ニュース・邦人NAVI",
            content: [
              {
                text: `「ニュース・邦人NAVI」では、ニュースサイトや人気ブログ、
								微信公衆号を通して配信されるビジネスや生活、レジャーなど
								様々なジャンルのフレッシュな情報がキャッチできます。
								また最近では、「動画」コーナーも設置され、日本で話題の
								ニュースやドラマなどをご覧いただけるようになっています。
								`
              }
            ]
          }
        ],
        listUrl: require("../components/images/home/help.png")
      },
      {
        header: `ツール`,
        body: [
          {
            title: "●翻訳機能",
            content: [
              {
                text: `日本語⇄中国語翻訳が可能です。`
              }
            ]
          },
          {
            title: "●為替計算機能（日本円・人民元）",
            content: [
              {
                text: `日本円及び人民元の為替計算ができます。`
              }
            ]
          },
          {
            title: "●フリマガ",
            content: [
              {
                text: `中国で東南アジアで発行されている日本語フリーペーバーの
								電子版の閲覧が可能です。
								`
              }
            ]
          },
          {
            title: "●引越し・レンタル",
            content: [
              {
                text: `日系大手物流会社のNX NIPPON EXPRESSへの引越しに
								関するお問い合わせが簡単にできます。
								また、浄水器やお掃除キットなどのレンタルに関する
								お問い合わせも可能です。
								`
              }
            ]
          }
        ],
        listUrl: require("../components/images/home/tool1.png")
      }
    ]
  },
  mutations: {
    getImgChanged(state, imgindex) {
      state.imgindex = imgindex;
    },
    getTextChanged(state, currentIndex) {
      state.currentIndex = currentIndex;
    }
  },
  getters: {
    recurrentIndex: state => {
      return state.currentIndex;
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js